/** @tossdocs-ignore */
function isNil(val) {
  return val == null;
}

export { isNil };
